import { fetchMeta } from '@doveconviene/react-sf-viewer/lib/Viewer/flux/api/application.api';
import { fetchJson } from 'utils/apiUrlUtils';

export const fetchFlyerPages = async (flyer) => {
  const publicationId = flyer ? flyer.publication_url.split('/').reverse()[0] : '';
  const publicationBasicUrl = process.env.REACT_APP_PUBLICATION_BASEURL;
  const pagesList = [];
  let baseImageUrl = null;
  const toFetch = [];
  await Promise.resolve(fetchMeta(publicationBasicUrl, publicationId)).then(({ baseUrl, pagesBundles }) => {
    baseImageUrl = baseUrl;
    let fetched = null;
    for (const [, bundleUrlPath] of Object.entries(pagesBundles)) {
      if (fetched !== bundleUrlPath) {
        toFetch.push(fetchJson(`${baseUrl}${bundleUrlPath}`));
        fetched = bundleUrlPath;
      }
    }
  });
  await Promise.all(toFetch).then((pagesBundle) => {
    for (const [, pageBundle] of Object.entries(pagesBundle)) {
      for (const pageData of Object.entries(pageBundle)) {
        const [, { pageNumber = null, pageRepresentationDescriptors = null } = {}] = pageData;
        if (pageNumber) {
          const pageUrls = pageRepresentationDescriptors.map(
            // eslint-disable-next-line no-loop-func
            (p) => {
              const {
                pageRepresentation: { resourcePath = null },
              } = p;
              return `${baseImageUrl}${resourcePath}`;
            }
          );
          pagesList.push({ pageNumber, pageUrls });
        }
      }
    }
  });
  return pagesList;
};
